import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT, GradeKey, GRADES_ORDER } from '@/enum';
import { PersonGrades } from '@/types/GradeInterface';
import { useGradeStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditGradesModal',
  props: {
    visible: { type: Boolean },
    personId: {},
    organizationId: {},
    organizationName: {},
    currentGrades: {}
  },
  emits: ['update:visible', EMIT.CANCEL, EMIT.SYNC],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const gradesStore = useGradeStore();

const visible = ref(props.visible);

// Sync internal visible with prop
watch(
  () => props.visible,
  (val) => {
    visible.value = val;
  },
);

// Emit update when internal visible changes
watch(visible, (val) => {
  emit('update:visible', val);
  if (!val) emit(EMIT.CANCEL);
});

const allGrades = GRADES_ORDER.map((gradeKey) => ({ grade: gradeKey }));

const selectedGrades = ref<{ grade: GradeKey }[]>([]);

// Sync selected grades when prop changes
watch(
  () => props.currentGrades,
  (newGrades) => {
    selectedGrades.value = allGrades.filter((g) => newGrades.some((ng) => ng.grade === g.grade));
  },
  { immediate: true },
);

const submit = async () => {
  const initial: GradeKey[] = props.currentGrades.map((g) => g.grade as GradeKey);
  const current: GradeKey[] = selectedGrades.value.map((g) => g.grade as GradeKey);

  const attached = current.filter((grade) => !initial.includes(grade));
  const detached = initial.filter((grade) => !current.includes(grade));

  if (attached.length === 0 && detached.length === 0) {
    gradesStore.doToast('No changes made to grades', '', true);
    visible.value = false;
    return;
  }

  if (detached.length > 0) {
    await gradesStore.detachPersonGrades({ grades: detached }, props.personId, props.organizationId);
    gradesStore.doToast('Grades detached successfully');
  }

  if (attached.length > 0) {
    await gradesStore.attachPersonGrades({ grades: attached }, props.personId, props.organizationId);
    gradesStore.doToast('Grades attached successfully');
  }
  emit(EMIT.SYNC);
  visible.value = false;
};

const close = () => {
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: "Edit Grades",
    closable: true,
    draggable: false,
    class: "dialog__container"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: close
      }),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        onClick: submit
      })
    ]),
    default: _withCtx(() => [
      (props.organizationName)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(props.organizationName), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_DataTable, {
        selection: selectedGrades.value,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((selectedGrades).value = $event)),
        value: _unref(allGrades),
        "data-key": "grade",
        "selection-mode": "multiple",
        "responsive-layout": "scroll",
        "aria-label": "Grades selection table"
      }, {
        empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("No grades to display.", -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            "selection-mode": "multiple",
            "header-style": "width:3rem"
          }),
          _createVNode(_component_Column, {
            field: "grade",
            header: "Grade"
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.grade), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selection", "value"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})